import { useModulesSubmitModuleResultMutation } from '@app/services/auto-generated/modules'
import { Modal, Box, Typography, Button, Link } from '@common/components'

const PrivacyModal = (props: { open: boolean; onClose: () => void }) => {
  const { open, onClose } = props
  const [sendModule] = useModulesSubmitModuleResultMutation()

  const handleSubmit = async () => {
    try {
      await sendModule({
        moduleResult: {
          id: 'PrivacyPolicyModule',
          data: { status: 'completed' },
        },
      })
      onClose()
    } catch (error) {
      console.error(error)
    }
  }
  return (
    <Modal
      showCloseBtn={false}
      open={open}
      onClose={() => {}}
      paperProps={{ sx: { p: 4, width: '100%', maxWidth: '650px' } }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
          Privacy Notice
        </Typography>

        <Typography variant='body1'>
          By continuing to Mentor AI, you acknowledge that you have read and agreed to our{' '}
          <Link
            href='https://www.notion.so/a07be00c0cb14e728bf66988141055c2?pvs=21'
            target='_blank'
          >
            Terms of Service
          </Link>{' '}
          and{' '}
          <Link
            href='https://www.notion.so/9c7e388113224c3fb953671a17ac22b4?pvs=21'
            target='_blank'
          >
            Privacy Policy
          </Link>
          , as well as the following privacy notice from the University of New South Wales:
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            pl: 2,
            borderLeft: '4px solid #e0e0e0',
            gap: 2,
          }}
        >
          <Typography variant='body1'>
            Personal information provided on this platform (including audio recordings and feedback
            interactions) will be used by the University for the purpose of supporting your language
            development.
          </Typography>

          <Typography variant='body1'>
            Your zID will be used for login only and is not linked to your recordings or feedback
            within the tool. The information is held in an encrypted form on Microsoft Azure. It
            will be retained for up to 180 days for your use and evaluation purposes, after which it
            will be securely deleted.
          </Typography>
          <Box>
            <Typography variant='body1'>
              Your audio submissions are not used to train AI models.
            </Typography>
            <Typography variant='body1'>Your participation is voluntary.</Typography>
            <Typography variant='body1'>
              All personal information is managed in accordance with the University's{' '}
              <Link
                href='https://www.unsw.edu.au/governance/policy/policy-hub/informationgovernancepolicy'
                target='_blank'
              >
                Information Governance Policy
              </Link>
              .
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2 }}>
          <Button variant='contained' onClick={handleSubmit}>
            Agree & Continue
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default PrivacyModal
